var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-simple"},[_c('el-header',{staticClass:"bar-simple-header"},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"space-between","align":"middle"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }